export default "__VITE_ASSET__Nwh_RX$3__"